import { render, staticRenderFns } from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=template&id=2058a84c&scoped=true"
import script from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=style&index=0&id=2058a84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058a84c",
  null
  
)

export default component.exports